module.exports = __webpack_public_path__ + "static/img/MV13.e7638fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV13.jpg
// module id = 62tG
// module chunks = 0